import { ReactionType } from "@outschool/animation-resources";

import DrawingImg from "../../../../images/club/attachments/drawing.png";
import EyeImg from "../../../../images/club/attachments/eye.png";
import FeedbackImg from "../../../../images/club/attachments/feedback.png";
import PersonDrawingImg from "../../../../images/club/attachments/person-drawing.png";
import ShareImg from "../../../../images/club/attachments/share.png";
import SplotchesImg from "../../../../images/club/attachments/splotches.png";
import WelcomeImg from "../../../../images/club/attachments/welcome.png";
import { ClubContextProps } from "../../../providers";
import { SAMPLE_CLUB_POST_AVATAR_URLS } from "./SampleClubPostAvatar";

export type SampleClubPostAttachments = {
  file: {
    mimetype: string | null;
    url: string;
    /**
     * Packaged webpack/static asset (not user-uploaded CDN media).
     * Callers should skip image transform for these URLs.
     */
    isBundledAsset?: boolean;
  };
}[];

/** Build a default sample attachment from a webpack-imported image. */
function bundledSampleImage(
  image: string | { src: string },
): SampleClubPostAttachments[number] {
  return {
    file: {
      mimetype: "image/png",
      url: typeof image === "string" ? image : image.src,
      isBundledAsset: true,
    },
  };
}

export type DefaultSampleClubPostComment = {
  text: string | null;
  attachments?: SampleClubPostAttachments | null;
  sender?: {
    uid: string;
    name: string;
    avatar: keyof typeof SAMPLE_CLUB_POST_AVATAR_URLS;
    backgroundColor: string | null;
  };
};

export interface SampleClubPostProps {
  sampleClubPost: {
    text: string | null;
    attachments?: SampleClubPostAttachments | null;
    video?: { file: { url: string } } | null;
    comments?: DefaultSampleClubPostComment[];
  };
  senderName?: string;
  useClubPostAndCommentDefaultBackgroundColor?: ClubContextProps["useClubPostAndCommentDefaultBackgroundColor"];
}

export type SampleClubPostActivity = {
  uid: string;
  title: string;
  sampleClubPosts: SampleClubPostProps["sampleClubPost"][];
  leader: { name?: string | null };
};
export const DEFAULT_SAMPLE_CLUB_POSTS: {
  text: string | null;
  attachments: SampleClubPostAttachments;
  comments: DefaultSampleClubPostComment[];
}[] = [
  {
    text: "Welcome to the Group! First daily challenge starts tomorrow",
    attachments: [bundledSampleImage(WelcomeImg)],
    comments: [
      {
        text: ReactionType.CELEBRATION_CLUB_REACTION,
        sender: {
          uid: "learner-1",
          name: "Learner",
          avatar: "apple-preview-avatar",
          backgroundColor: "#006ADC",
        },
      },
      {
        text: "I'm so excited!",
        sender: {
          uid: "learner-2",
          name: "Learner",
          avatar: "monkey-preview-avatar",
          backgroundColor: "#068474",
        },
      },
      {
        text: ReactionType.SUNGLASSES_CLUB_REACTION,
        sender: {
          uid: "learner-3",
          name: "Learner",
          avatar: "marsupial-preview-avatar",
          backgroundColor: "#4251D7",
        },
      },
      {
        text: "This is awesome!! I cannot wait to get started on all the amazing challenges!🎉",
        sender: {
          uid: "learner-4",
          name: "Learner",
          avatar: "monster-preview-avatar-1",
          backgroundColor: "#644FC1",
        },
      },
      {
        text: "I can't wait!! This is going to be so fun!!🎉😝",
        sender: {
          uid: "learner-5",
          name: "Learner",
          avatar: "monster-preview-avatar-1",
          backgroundColor: "#AF42D7",
        },
      },
      {
        text: ReactionType.THUMBS_UP_CLUB_REACTION,
        sender: {
          uid: "learner-6",
          name: "Learner",
          avatar: "apple-preview-avatar",
          backgroundColor: "#DB2F74",
        },
      },
    ],
  },
  {
    text: "Need feedback on your project? Ask here!",
    attachments: [bundledSampleImage(FeedbackImg)],
    comments: [
      {
        text: "This is awesome! 😃",
        sender: {
          uid: "learner-7",
          name: "Learner",
          avatar: "monkey-preview-avatar",
          backgroundColor: "#D83B40",
        },
      },
      {
        text: ReactionType.FIRE_CLUB_REACTION,
        sender: {
          uid: "learner-8",
          name: "Learner",
          avatar: "mug-preview-avatar",
          backgroundColor: "#006ADC",
        },
      },
      {
        text: ReactionType.LETS_GO_CLUB_REACTION,
        sender: {
          uid: "learner-9",
          name: "Learner",
          avatar: "marsupial-preview-avatar",
          backgroundColor: "#4251D7",
        },
      },
      {
        text: "YESSS!!! This is what I’m looking for 🎉",
        sender: {
          uid: "learner-10",
          name: "Learner",
          avatar: "monster-preview-avatar-1",
          backgroundColor: "#DB2F74",
        },
      },
      {
        text: "Can you look at the video I posted yesterday? Thank you!",
        sender: {
          uid: "learner-11",
          name: "Learner",
          avatar: "monster-preview-avatar-1",
          backgroundColor: "#006ADC",
        },
      },
      {
        text: ReactionType.CARE_CLUB_REACTION,
        sender: {
          uid: "learner-12",
          name: "Learner",
          avatar: "donut-preview-avatar",
          backgroundColor: "#255DAD",
        },
      },
    ],
  },
  {
    text: "Share your work!",
    attachments: [bundledSampleImage(ShareImg)],
    comments: [
      {
        text: "",
        attachments: [bundledSampleImage(EyeImg)],
        sender: {
          uid: "learner-13",
          name: "Learner",
          avatar: "turtle-preview-avatar",
          backgroundColor: "#D83B40",
        },
      },
      {
        text: ReactionType.HEARTS_CLUB_REACTION,
        sender: {
          uid: "learner-14",
          name: "Learner",
          avatar: "marsupial-preview-avatar",
          backgroundColor: "#006ADC",
        },
      },
      {
        text: "",
        attachments: [bundledSampleImage(DrawingImg)],
        sender: {
          uid: "learner-15",
          name: "Learner",
          avatar: "star-preview-avatar",
          backgroundColor: "#4251D7",
        },
      },
      {
        text: "",
        attachments: [bundledSampleImage(SplotchesImg)],
        sender: {
          uid: "learner-16",
          name: "Learner",
          avatar: "monster-preview-avatar-2",
          backgroundColor: "#DB2F74",
        },
      },
      {
        text: "",
        attachments: [bundledSampleImage(PersonDrawingImg)],
        sender: {
          uid: "learner-17",
          name: "Learner",
          avatar: "monster-preview-avatar-2",
          backgroundColor: "#006ADC",
        },
      },
      {
        text: "Everyone is so talented!",
        sender: {
          uid: "learner-18",
          name: "Learner",
          avatar: "astronaut-preview-avatar",
          backgroundColor: "#DB2F74",
        },
      },
    ],
  },
];
